import { API_PATHS } from "../constants/api-paths";
import { IResponse, encryptedRequest } from "../core/api.client";

export interface ICorporateFdResponse {
  statusCode: string;
  description?: string;
  fetchFdCorporateRoiDetails?: FetchFdCorporateRoiDetails;
}
interface FetchFdCorporateRoiDetails {
  id: string;
  masterkey: string;
  callable: FdRoiItem[];
  nonCallable: FdRoiItem[];
}
interface FdRoiItem {
  maturityPeriod: string;
  between25To50Cr: string;
  between50To100Cr: string;
  moreThan100Cr: string;
  refreshDate: string;
}

export const getFdCorporateInterestRateData = async (data: {
  fcrfid: string;
}): Promise<IResponse<ICorporateFdResponse>> => {
  const response = await encryptedRequest<ICorporateFdResponse>({
    method: "POST",
    url: API_PATHS.fdcorporateroifetch,
    data,
  });
  return response;
};
